(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nex-guarantees"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bootGuarantees = () => {
      const bands = document.querySelectorAll("[data-nex-guarantees]");
      if (!bands.length) return;
      // No IntersectionObserver -> show everything immediately.
      if (!("IntersectionObserver" in window)) {
        bands.forEach((band) => band.classList.add("is-revealed"));
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.3, rootMargin: "0px 0px -8% 0px" },
      );
      bands.forEach((band) => {
        band.classList.add("is-reveal-ready");
        observer.observe(band);
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootGuarantees, { once: true });
    } else {
      bootGuarantees();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
